import styled from 'styled-components';

export const Wrapper = styled.div`
    display: block;
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: -50px;
`;

export const Container = styled.div`
    display: block;
    max-width: calc(100% - 20px);
    width: 1360px;
    margin: 0 auto;
    @media(max-width: 1550px) {
        width: 1032px;
    }
    @media(max-width: 1240px) {
        width: 803px;
    }
    @media(max-width: 985px) {
        width: 700px;
    }
    @media(max-width: 720px) {
        width: calc(100% - 30px);
    }
`;
